// File: @/router/index.js

import Vue from "vue";
import Router from "vue-router";
import { setupRouterMiddleware, auth, guest, permission } from "@/middleware";

// Authentication 
import Login from "@/views/Authentication/LoginForm.vue";
import Register from "@/views/Authentication/RegisterForm.vue";
import ForgetPassword from "@/views/Authentication/ForgetPasswordForm.vue";
import ResetPassword from "@/views/Authentication/ResetPasswordForm.vue";
import EmailVerify from "@/views/Authentication/Verify.vue";

import Dashboard from "@/layouts/DashboardLayout.vue";

// Frontend 
import index from "@/views/Frontend/index.vue";
import PageContent from "@/views/Frontend/PageContent.vue";
import ProductsFilters from "@/views/Frontend/Product/ProductsFilters.vue";
import Profile from "@/views/Frontend/user/SellerInformation.vue";
import ProductID from "@/views/Frontend/Product/ProductID.vue";
import AddNewProduct from "@/views/Frontend/Product/AddNewProduct.vue";
import SellingStepsExplanation from "@/views/Frontend/Product/SellingStepsExplanation.vue";
import ProductCreatedSuccess from "@/views/Frontend/Product/ProductCreatedSuccess.vue";
import CheckoutOrder from "@/views/Frontend/checkout/CheckoutOrder.vue";

import Faq from "@/views/Frontend/others/Faq.vue";
import Contact from "@/views/Frontend/others/Contact.vue";
import PrivacyPolicy from "@/views/Frontend/others/PrivacyPolicy.vue";
import CookiesPolicy from "@/views/Frontend/others/CookiesPolicy.vue";
import TermsOfUse from "@/views/Frontend/others/TermsOfUse.vue";

// Dashboard 
import DashboardComponent from "@/views/Dashboard/DashboardBase.vue";
import Messenger from "@/views/Dashboard/messenger/index.vue";

import ManageAdmin from "@/views/Dashboard/manage/Admin.vue";
import ManageUsers from "@/views/Dashboard/manage/User.vue";

import Account from "@/views/Dashboard/user/Account.vue";
import manageAccount from "@/views/Dashboard/user/manageAccount.vue";
import languageSwitcher from "@/views/Dashboard/user/languageSwitcher.vue";
import PasswordPage from "@/views/Dashboard/user/PasswordPage.vue";
import AccountCredentials from "@/views/Dashboard/user/AccountCredentials.vue";
import AccountInformations from "@/views/Dashboard/user/AccountInformations.vue";
import ProPage from "@/views/Dashboard/user/ProPage.vue";

import manageChatbot from "@/views/Dashboard/manage/ChatbotAdmin.vue";
import manageBoosterPlans from "@/views/Dashboard/manage/BoosterPlans.vue";
import manageBoosterPlansList from "@/views/Dashboard/manage/BoosterPlansList.vue";
import manageBoosterPurchaseList from "@/views/Dashboard/manage/BoosterPurchaseList.vue";
import managePaymentTypes from "@/views/Dashboard/manage/PaymentType.vue";

import manageProductReport from "@/views/Dashboard/report/ProductReportList.vue";

import ManageFaqs from "@/views/Dashboard/manage/Faq.vue";
import ManageStores from "@/views/Dashboard/manage/Stores.vue";
import ManageCategories from "@/views/Dashboard/manage/Categories.vue";

import MySales from "@/views/Dashboard/Product/MySales.vue";
import MyPurchases from "@/views/Dashboard/Product/MyPurchases.vue";
import ListNewProduct from "@/views/Dashboard/Product/ListNewProduct.vue";
import ListProduct from "@/views/Dashboard/Product/ListProduct.vue";
import ListUserProducts from "@/views/Dashboard/Product/ListUserProducts.vue";
import ListNonSoldProduct from "@/views/Dashboard/Product/ListNonSoldProduct.vue";
import ResellProduct from "@/views/Dashboard/Product/ResellProduct.vue";
// import MyReceivedOffers from "@/views/Dashboard/Product/MyReceivedOffers.vue";
// import MyReceivedAuctions from "@/views/Dashboard/Product/MyReceivedAuctions.vue";
import ProductManagement from "@/views/Dashboard/Product/ProductManagement.vue";
import BoostPlanManagement from "@/views/Dashboard/booster/BoostPlanManagement.vue";
import BoostPlanManagementAfterCreate from "@/views/Dashboard/booster/BoostPlanManagementAfterCreate.vue";

import ManagePermissions from "@/views/Dashboard/manage/Permissions.vue";
import ManageFavorites from "@/views/Dashboard/favorite/list.vue";
import Cart from "@/views/Dashboard/cart/list.vue";
import MyOperations from "@/views/Dashboard/transactions/Client.vue";
import MyOperationId from "@/views/Dashboard/operations/id.vue";

import StoreProducts from "@/views/Dashboard/Store/StoreProducts.vue";
import AddStore from "@/views/Dashboard/Store/AddStore.vue";
import OffersBids from "@/views/Dashboard/offers_bids/list.vue";

import BidsList from "@/views/Dashboard/bids/bids_list.vue";

import ClientWallet from "@/views/Dashboard/Wallet/Client.vue";
import AdminWallet from "@/views/Dashboard/Wallet/Admin.vue";

import ManageDelivery from "@/components/dashboard/Delivery/ManageDelivery.vue";

import ProductEdit from "@/components/add-product/AddNewProductComp.vue";

import PageEditor from "@/components/dashboard/Legal/PageEditor.vue";

import ShowInvoice from "@/components/templates/Invoice.vue";

import TestProducts from "@/components/products/testProducts.vue";

import ListAllCategories from "@/components/category/ListAll.vue";
import ProductsList from "@/views/Dashboard/Product/List.vue";

import NotAutorised from "@/views/errors/401.vue";
import Forbidden from "@/views/errors/403.vue";
import NotFound from "@/views/errors/404.vue";

Vue.use(Router);

const router=new Router({
  mode: "history",
  routes: [
    /**************** Root (Dashboard,Home) ******************/
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        middleware: [auth]
      },
      redirect: "dashboardBase",
      children: [
        {
          path: "/dashboard/:activeTab?",
          name: "dashboardBase",
          component: DashboardComponent,
          meta: {
            middleware: [auth]
          }
        },
        /**************** Admin Management ******************/
        {
          path: "/manage/admin",
          name: "manageAdmin",
          component: ManageAdmin,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/users/:id?",
          name: "manageUsers",
          component: ManageUsers,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/categories",
          name: "manageCategories",
          component: ManageCategories,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/stores",
          name: "manageStores",
          component: ManageStores,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/faqs",
          name: "manageFaqs",
          component: ManageFaqs,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/product/list/new/:id?",
          name: "listNewProduct",
          component: ListNewProduct,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/product/list/:state?",
          name: "listProduct",
          component: ListProduct,
          meta: {
            middleware: [auth, permission]
          }
        },
        /**************** User  ******************/
        {
          path: "/user/account",
          name: "account",
          component: Account,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/user/manage-account",
          name: "manageAccount",
          component: manageAccount,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/user/language",
          name: "languageSwitcher",
          component: languageSwitcher,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/account-credentials",
          name: "AccountCredentials",
          component: AccountCredentials,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/profile/password",
          name: "PasswordPage",
          component: PasswordPage,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/profile/informations",
          name: "AccountInformations",
          component: AccountInformations,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/profile/pro",
          name: "ProPage",
          component: ProPage,
          meta: {
            middleware: [auth]
          }
        },
        /**************** Dashboard Client  ******************/
        {
          path: "/mySales",
          name: "mySales",
          component: MySales,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/my-operations/:activeTab?",
          name: "myOperations",
          component: MyOperations,
          meta: {
            middleware: [auth]
          }
        }, 
        {
          path: "/offers_bids",
          name: "OffersBids",
          component: OffersBids,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/bids",
          name: "BidsList",
          component: BidsList,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/my-operations/:id",
          name: "MyOperationId",
          component: MyOperationId,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/myPurchases",
          name: "myPurchases",
          component: MyPurchases,
          meta: {
            middleware: [auth]
          }
        },
        {
          // accept optional id and offerId params while keeping base /messenger route working
          path: "/messenger/:id?",
          name: "messenger",
          component: Messenger,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/my-products",
          name: "myproducts",
          component: ProductsList,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/products-list",
          name: "productslist",
          component: ProductsList,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/list/user/products",
          name: "listUserProducts",
          component: ListUserProducts,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/store/add",
          name: "addStore",
          component: AddStore,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/invoice",
          name: "showInvoice",
          component: ShowInvoice,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/edit/privacy_policy",
          name: "privacyPolicyEdit",
          component: PageEditor,
          props: { pageType: "privacy_policy" },
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/edit/cookies_policy",
          name: "cookiesPolicyEdit",
          component: PageEditor,
          props: { pageType: "cookies_policy" },
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/edit/terms_of_use",
          name: "termsOfUseEdit",
          component: PageEditor,
          props: { pageType: "terms_of_use" },
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/delivery",
          name: "manageDelivery",
          component: ManageDelivery,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/resell/product/:id",
          name: "resellProduct",
          component: ResellProduct,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/product/nonSold",
          name: "ListNonSoldProduct",
          component: ListNonSoldProduct,
          meta: {
            middleware: [auth]
          }
        },
        // {
        //   path: "/product/offers-received",
        //   name: "MyReceivedOffers",
        //   component: MyReceivedOffers,
        //   meta: {
        //     middleware: [auth]
        //   }
        // },
        // {
        //   path: "/product/auctions-received",
        //   name: "MyReceivedAuctions",
        //   component: MyReceivedAuctions,
        //   meta: {
        //     middleware: [auth]
        //   }
        // },
        {
          path: "/wallet",
          name: "ClientWallet",
          component: ClientWallet,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/manage/wallet",
          name: "AdminWallet",
          component: AdminWallet,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/permissions",
          name: "ManagePermissions",
          component: ManagePermissions,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/cart",
          name: "Cart",
          component: Cart,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/manage/favorites",
          name: "ManageFavorites",
          component: ManageFavorites,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/product/edit/:id?",
          name: "ProductEdit",
          component: ProductEdit,
          meta: {
            middleware: [auth]
          },
          props: {
            title: "sentence.updateYourProduct"
          }
        },
        {
          path: "/product-boost/:id",
          name: "BoostPlanManagement",
          component: BoostPlanManagement,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/product-manage/:id?",
          name: "ProductManagement",
          component: ProductManagement,
          meta: {
            middleware: [auth]
          }
        },
        {
          path: "/manage/chatbot",
          name: "manageChatbot",
          component: manageChatbot,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/payment-types",
          name: "managePaymentTypes",
          component: managePaymentTypes,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/booster-plans",
          name: "manageBoosterPlans",
          component: manageBoosterPlans,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/booster-plans-list",
          name: "manageBoosterPlansList",
          component: manageBoosterPlansList,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/booster-purchase-list",
          name: "manageBoosterPurchaseList",
          component: manageBoosterPurchaseList,
          meta: {
            middleware: [auth, permission]
          }
        },
        {
          path: "/manage/product-report-list",
          name: "manageProductReport",
          component: manageProductReport,
          meta: {
            middleware: [auth, permission]
            // middleware: [auth]
          }
        }
      ]
    },
    /**************** Public Routes ******************/
    {
      path: "/",
      name: "index",
      component: index
    },
    /**************** Authentication ******************/
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        middleware: [guest]
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        middleware: [guest]
      }
    },
    {
      path: "/forgot",
      name: "forgot",
      component: ForgetPassword,
      meta: {
        middleware: [guest]
      }
    },
    {
      path: "/reset",
      name: "reset",
      component: ResetPassword,
      meta: {
        middleware: [guest]
      }
    },
    {
      path: "/email/verify/:id",
      name: "emailVerify",
      component: EmailVerify
    },
    /**************** General Action  ******************/
    {
      path: "/contact",
      name: "contact",
      component: Contact
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq
    },
    {
      path: "/checkout/:type/:id",
      name: "checkoutOrder",
      component: CheckoutOrder,
      meta: {
        middleware: [auth]
      }
    },
    {
      path: "/batch/create/:id",
      name: "BatchCreate",
      component: () => import('@/views/Frontend/batch/Create.vue'),
      meta: {
        middleware: [auth]
      }
    },
    {
      path: '/batch-view/:seller_id',
      name: 'BatchView',
      component: () => import('@/views/Frontend/batch/View.vue'),
      props: true
    },
    {
      path: "/product/success/:id",
      name: "ProductCreatedSuccess",
      component: ProductCreatedSuccess,
      meta: {
        middleware: [auth]
      }
    },
    {
      path: "/product-create-boost/:id",
      name: "BoostPlanManagementAfterCreate",
      component: BoostPlanManagementAfterCreate,
      meta: {
        middleware: [auth]
      }
    },
    {
      path: "/products-filters",
      name: "ProductsFilters",
      component: ProductsFilters,
      beforeRouteUpdate(to, from, next) {
        this.id=to.params.id;
        next();
      }
    },
    {
      path: "/test",
      name: "test",
      component: TestProducts
    },
    {
      path: "/products/:id?",
      name: "productDetails",
      component: ProductID
    },
    {
      path: "/profile/:id",
      name: "Profile",
      component: Profile
    },
    {
      path: "/store/:id?",
      name: "storeProducts",
      component: StoreProducts
    },
    {
      path: "/categories/all/:id?",
      name: "listCategories",
      component: ListAllCategories
    },
    /**************** Product  ******************/
    {
      path: "/selling/step/explanation",
      name: "SellingStepsExplanation",
      component: SellingStepsExplanation
    },
    {
      path: "/product/sell",
      name: "productSell",
      component: AddNewProduct,
      meta: {
        middleware: [auth]
      }
    },
    /**************** Legal Pages ******************/
    {
      path: "/privacy_policy",
      name: "privacyPolicyPage",
      component: PrivacyPolicy
    },
    {
      path: "/cookies_policy",
      name: "cookiesPolicyPage",
      component: CookiesPolicy
    },
    {
      path: "/terms_of_use",
      name: "termsOfUsePage",
      component: TermsOfUse
    },
    {
      path: "/page/:type",
      name: "pageContent",
      component: PageContent,
      props: route => ({
        type: route.params.type,
        name: {
          privacy_policy: "Politique de confidentialité",
          cookies_policy: "Politique de cookies",
          terms_of_use: "Condition d'utilisation",
        }[route.params.type]||"Page",
      })
    },
    /**************** Error Pages ******************/
    {
      path: "/401",
      name: "401",
      component: NotAutorised
    },
    {
      path: "/403",
      name: "403",
      component: Forbidden
    },
    /**************** 404 Not Found - Must be last ******************/
    {
      path: "*",
      name: "404",
      component: NotFound
    }
  ]
});

// Setup the middleware system
setupRouterMiddleware(router);

export default router;